<template>
  <div>
    <el-form
      :model="queryParams"
      :rules="rules"
      ref="basicInfo"
      style="margin-bottom: 0; background-color: #fff; padding: 20px"
      label-width="140px"
    >
      <el-form-item label="超级个体编号：" prop="superIndividualId">
        <el-input
          v-model="queryParams.superIndividualId"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="超级个体姓名：" prop="name">
        <el-input v-model="queryParams.name" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="超级个体昵称：" prop="nickname">
        <el-input v-model="queryParams.nickname" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="超级个体描述：" prop="description">
        <el-input
          type="textarea"
          v-model="queryParams.description"
          placeholder="请输入"
          resize="none"
          rows="5"
          maxlength="500"
        />
      </el-form-item>

      <el-form-item label="超级个体价值描述：" prop="valueDescription">
        <el-input
          v-model="queryParams.valueDescription"
          type="textarea"
          placeholder="超级个体价值描述："
          resize="none"
          rows="5"
          maxlength="500"
        />
      </el-form-item>

      <el-form-item label="上级超级个体编号：" prop="superiorId">
        <el-input
          v-model="queryParams.superiorId"
          placeholder="上级超级个体编号："
        />
      </el-form-item>

      <el-form-item label="上级超级个体名称：" prop="superiorName">
        <el-input v-model="queryParams.superiorName" placeholder="请输入" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// utils
import { debounce } from "@/utils/index.js";

export default {
  name: "EnterpriseInfo",
  components: {},
  data() {
    return {
      queryParams: {
        // 超级个体编号（唯一标识）
        superIndividualId: "",
        // 超级个体姓名（带星号表示必填字段）
        name: "",
        // 超级个体昵称（展示用别名）
        nickname: "",
        // 超级个体详细描述
        description: "",
        // 价值描述（个体价值定位）
        valueDescription: "",
        // 上级超级个体编号（关联上级）
        superiorId: "",
        // 上级超级个体名称（展示用）
        superiorName: "",
      },
      isInit: false,
      rules: {
        name: [
          { required: true, message: "请输入超级个体姓名", trigger: "blur" }
        ],
      },
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.company {
  background: #fff;
  padding: 20px 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .company_left {
    display: flex;
    .info {
      margin-left: 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .fullName {
        display: flex;
        align-items: center;
        .jr-iconjr-icon-edit1:hover {
          color: #4d77ff;
        }
        .el-button {
          margin-left: 10px;
        }
        .companyFullName {
          font-size: 24px;
          color: #363e4d;
        }
        i {
          margin-left: 10px;
        }
      }

      .updateTime {
        color: #7c7f8e;
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }
  .company_right {
    font-size: 12px;
    color: #7c7f8e;
  }
}
/deep/ .el-tabs__content {
  overflow: auto;
}
.companyInfo {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0;
  }
  .avatar {
    margin-right: 20px;
  }
}

.bottom {
  border-top: 1px solid #dbdbdb;
  background: #fff;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  .el-button {
    margin: 0 20px;
  }
}
.leave {
  width: 426px !important;
  height: 84px !important;
  padding: 10px 0;
  background: #f5f6f7;
}
::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  width: 470px;
}
</style>
